import React, { Fragment } from 'react';
import blogs from '../../api/blogs';
import { useParams, Link } from 'react-router-dom';
import PageTitle from '../../components/pagetitle/PageTitle';
import NavbarS4 from '../../components/NavbarS4/NavbarS4';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';
import Logo from '../../images/logo.jpeg';
import BlogSidebar from '../../components/BlogSidebar/BlogSidebar';

const BlogDetails = () => {
    const { slug } = useParams();
    const Details = blogs.find(item => item.slug === slug);

    if (!Details) return null;

    return (
        <Fragment>
            <NavbarS4
                hclass={'wpo-site-header wpo-header-style-s11'}
                Logo={Logo}
                col1={'col-lg-3 col-md-3 col-3 d-lg-none dl-block'}
                col2={'col-lg-2 col-md-4 col-6'}
                col3={'col-lg-7 col-md-1 col-1'}
                col4={'col-lg-3 col-md-4 col-2'}
            />

            <PageTitle pageTitle={Details.title} pagesub={'Blog Details'} />

            <section className="wpo-blog-single-section section-padding pt-0">
                <div className="container-fluid">
                    <div className="wpo-blog-wraper">
                        <div className="wpo-blog-content">
                            <div className="post format-standard-image">
                                <div className="entry-media">
                                    <img src={Details.blogSingleImg} alt="" />
                                </div>

                                <div className="entry-meta">
                                    <ul>
                                        <li>By:<Link to="/blog"> admin </Link></li>
                                        <li>Date: {Details.create_at}</li>
                                    </ul>
                                </div>

                                {/* ================= BLOG 1 ================= */}
                                {slug === 'future-of-architectural-design-in-india' && (
                                    <>
                                        <p>
                                            <span>A</span>rchitecture in India is experiencing a powerful transformation,
                                            driven by rapid urbanization, evolving lifestyles, and the growing need for
                                            sustainable development. Modern architectural design has moved far beyond
                                            visual aesthetics and now focuses on long-term functionality, environmental
                                            responsibility, and structural efficiency.
                                        </p>

                                        <p>
                                            Today’s buildings must respond intelligently to climate, site conditions,
                                            regulations, and future adaptability. Architectural planning plays a critical
                                            role in optimizing space utilization, ensuring structural safety, and
                                            integrating modern construction technologies that enhance durability and
                                            performance.
                                        </p>

                                        <p>
                                            Professional architectural firms adopt a holistic approach that combines
                                            creative design with technical precision. From concept development and
                                            statutory approvals to detailed drawings and execution coordination, every
                                            stage contributes to the success of a project.
                                        </p>

                                        <blockquote>
                                            Architecture succeeds when form, function, and sustainability work together.
                                            <h4>- YV Reddy Associates</h4>
                                        </blockquote>

                                        <h2>Building Functional & Future-Ready Spaces</h2>

                                        <p>
                                            Contemporary architecture emphasizes smart layouts, efficient circulation,
                                            natural lighting, and cross-ventilation. These elements not only enhance user
                                            comfort but also reduce energy consumption and operational costs over time.
                                        </p>

                                        <p>
                                            Sustainable architectural practices involve material efficiency, waste
                                            reduction, and environmentally responsible design decisions. Buildings
                                            designed with longevity in mind offer greater value, adaptability, and
                                            relevance in the long run.
                                        </p>

                                        <p>
                                            With decades of experience in architectural planning and execution, firms like
                                            YV Reddy Associates continue to deliver spaces that balance innovation with
                                            practicality—creating timeless environments built for generations.
                                        </p>
                                    </>
                                )}

                                {/* ================= BLOG 2 ================= */}
                                {slug === 'professional-office-interior-design' && (
                                    <>
                                        <p>
                                            <span>O</span>ffice interior design has become a vital component of modern
                                            business strategy. A thoughtfully designed workspace directly impacts
                                            productivity, employee well-being, collaboration, and brand perception.
                                        </p>

                                        <p>
                                            Modern organizations require work environments that support flexibility,
                                            efficiency, and comfort. Office interiors must align with operational
                                            workflows while also reflecting corporate identity and values.
                                        </p>

                                        <p>
                                            Professional office interior planning ensures optimal space utilization,
                                            ergonomic furniture selection, efficient lighting, and acoustic comfort.
                                            These factors collectively enhance focus, reduce fatigue, and improve
                                            overall workplace performance.
                                        </p>

                                        <blockquote>
                                            Well-designed offices empower people and elevate performance.
                                            <h4>- YV Reddy Associates</h4>
                                        </blockquote>

                                        <h2>Designing Workspaces That Perform</h2>

                                        <p>
                                            Strategic space planning enables better collaboration, smooth circulation,
                                            and flexibility for future growth. Poorly designed offices often result in
                                            underutilized areas, frequent modifications, and reduced employee
                                            satisfaction.
                                        </p>

                                        <p>
                                            Professional interior execution ensures quality materials, precise detailing,
                                            and adherence to timelines. Turnkey interior solutions further streamline
                                            coordination, providing clients with a seamless and stress-free experience.
                                        </p>

                                        <p>
                                            Investing in expert office interior design is no longer optional—it is a key
                                            driver of productivity, efficiency, and long-term business success.
                                        </p>
                                    </>
                                )}

                                {/* ================= BLOG 3 ================= */}
                                {slug === 'turnkey-contracting-services' && (
                                    <>
                                        <p>
                                            <span>T</span>urnkey contracting offers a comprehensive solution for clients
                                            seeking efficient and hassle-free project execution. It provides a single
                                            point of responsibility covering design, procurement, construction, and
                                            final handover.
                                        </p>

                                        <p>
                                            Traditional project models often involve multiple vendors, fragmented
                                            communication, and coordination challenges. Turnkey execution eliminates
                                            these issues by integrating all phases under one unified management system.
                                        </p>

                                        <p>
                                            Clients benefit from clear accountability, accurate budgeting, and realistic
                                            timelines. Every aspect of the project is planned, monitored, and executed
                                            with precision to ensure consistent quality.
                                        </p>

                                        <blockquote>
                                            Turnkey solutions deliver clarity, control, and confidence.
                                            <h4>- YV Reddy Associates</h4>
                                        </blockquote>

                                        <h2>Seamless Execution from Concept to Completion</h2>

                                        <p>
                                            Turnkey projects ensure that design intent is preserved throughout execution.
                                            Detailed planning, skilled supervision, and strict quality control result in
                                            durable and functional spaces delivered on schedule.
                                        </p>

                                        <p>
                                            Whether residential villas, commercial offices, or institutional facilities,
                                            turnkey contracting minimizes risk while maximizing efficiency and outcome
                                            quality.
                                        </p>

                                        <p>
                                            For clients seeking reliability, transparency, and superior execution,
                                            turnkey contracting remains the most effective approach to modern
                                            construction and interior projects.
                                        </p>
                                    </>
                                )}
                            </div>
                        </div>

                        <BlogSidebar />
                    </div>
                </div>
            </section>

            <Footer />
            <Scrollbar />
        </Fragment>
    );
};

export default BlogDetails;
